import React from 'react'
import { Link } from "react-router-dom";
import styled from "styled-components"
function Venue({name, img, slug, price,rating, capacity}) {
    return (
        <VenueContainer className="col-md-6 card">
            <Link to={`/venues/${slug}`}>
            <div className="img-container">
                    <img src={img} className="card-img-top pt-3" />
            </div>
            <div className="card-footer">
                <p className="name mb-0">{name}</p>
                <div>
                <span className="capacity-title">Capacity:  </span>
                <span className="capacity">{capacity}   </span> 
                <i class="fas fa-users mr-4"></i>
                <span className="capacity-title">Rating:  </span>
                        <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
                 <span className="rating">      {rating}</span>
                 <div>
                            <span className="price-tag">${price}.00</span>
                            <span className="price-label">   Per Hour</span>
                 </div>
                 </div>
            </div>
         </Link>
        </VenueContainer>
        )
}
export const VenueContainer = styled.div`
a{
color: black!important;
}
font-family: var(--font);
color: black;
img{
object-fit: cover;
height: 250px;
}
.capacity-title{
    color: gray;
    font-weight: 500;
    font-size: 1.2rem;
}
.name{
    font-size: 1.6rem!important;
    font-weight: 600;
}
.capacity, .rating{
    font-size: 1.2rem;
    color:gray;
}
.fa-star, .fa-users{
    color: rgb(230, 102, 102);
    font-size: 1rem;
}
.price-tag{
    font-size: 1.2rem;
    color:#B22222;
    font-weight: 600;
}
.price-label{
     font-size: 1.2rem;
    color:gray;
    font-weight: 600;
}


`
export default Venue
